"use strict";

if (document.querySelector('.menu-toggle')) {
  document.querySelector('.menu-toggle').addEventListener('click', menu, false);
}

function menu(event) {
  if (!event.target.closest('.menu-toggle-wrapper').querySelector('.menu-toggle-container').classList.contains('open')) {
    event.target.closest('.menu-toggle-wrapper').querySelector('.menu-toggle-container').classList.add('open');
    document.querySelector('body').classList.add('modal-open');
    event.currentTarget.classList.add('open');
  } else {
    event.target.closest('.menu-toggle-wrapper').querySelector('.menu-toggle-container').classList.remove('open');
    document.querySelector('.menu-toggle').classList.remove('open');
    document.querySelector('body').classList.remove('modal-open');
    event.currentTarget.classList.remove('open');
  }

  return false;
}